import React, { Component } from 'react'
import { observer } from 'mobx-react'
import './styles.scss'
import '../../styles/index.scss'

import CircleCheckmarkSVG from '../../assets/img/circle-checkmark.svg'

class FAAConfirmationMessage extends Component {
  render () {
    return (
      <div className='confirmMessage'>
        <img src={CircleCheckmarkSVG} alt='x' height='28' width='28' />
        <h3> Thank you for your submission.</h3>
        <p>Your confirmation number is <span>{this.props.Store.confirmationNumber}</span>. Please retain this number for your records. You will also receive confirmation with this information at the email addresses that you provided on the form.</p>
      </div>
    )
  }
}

export default observer(FAAConfirmationMessage)
